import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxntStepperComponent } from './rxnt-stepper.component';

@NgModule({
  declarations: [
    RxntStepperComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RxntStepperComponent,
  ],
})
export class RxntStepperModule {
}
